import { getCurrentSelectablefontsWithParams } from '@wix/santa-core-utils/dist/fonts';

export const fonts = getCurrentSelectablefontsWithParams('UGC', ['latin']);
